export default "__VITE_ASSET__DLH0YO$W__"